// extracted by mini-css-extract-plugin
export default {"logo":"EndGame_logo__tqA2r","end":"EndGame_end__CMwiF","champ":"EndGame_champ__SdiB6","score":"EndGame_score__ereIb"};